// format.ts — display formatting shared by every page: millimetre readouts,
// dates, the scan-status → badge-tone map, and tag parsing for the Details
// card. Pure functions, no React.

import type { ScanDimensions, ScanStatus } from './api';
import type { StatusTone } from 'common';

export function fmtMm(mm: number | null | undefined, digits = 1): string {
  if (mm == null || !Number.isFinite(mm)) return '—';
  return `${mm.toFixed(digits)} mm`;
}

export function fmtDims(d: ScanDimensions | null | undefined): string {
  if (!d) return 'not measured yet';
  return `${d.length_mm.toFixed(1)} × ${d.width_mm.toFixed(1)} × ${d.height_mm.toFixed(1)} mm`;
}

export function fmtDate(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return d.toLocaleString(undefined, { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit' });
}

export function fmtCount(n: number): string {
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)}M`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(1)}k`;
  return String(n);
}

export function statusTone(s: ScanStatus): StatusTone {
  switch (s) {
    case 'ready':
      return 'success';
    case 'refining':
      return 'info';
    case 'capturing':
      return 'warning';
    case 'failed':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function parseTags(text: string): string[] {
  return [...new Set(text.split(',').map((t) => t.trim()).filter(Boolean))];
}

export function errorMessage(err: unknown): string {
  return err instanceof Error ? err.message : String(err);
}
